/**
 * Effect Composer types - extracted to break circular dependency
 * between EffectComposerPass.ts and EffectComposer.ts
 */
import type * as THREE from "three";

export interface EffectComposerPassInterface {
  enabled: boolean;
  childEffects?: EffectComposer;
  setSize(width: number, height: number): void;
  setSizeWithPixelRatio(width: number, height: number, pixelRatio: number): void;
  render(renderer: THREE.WebGLRenderer, writeBuffer: THREE.WebGLRenderTarget | null): void;
}

export type EffectComposer = (EffectComposerPassInterface | EffectComposerPassInterface[])[];

export function effectComposerSetSize(effects: EffectComposer, width: number, height: number): void {
  for (const effect of effects) {
    if (Array.isArray(effect)) {
      for (const subEffect of effect) {
        subEffect.setSize(width, height);
      }
    } else {
      effect.setSize(width, height);
    }
  }
}
